const getters = {
  loaded: state => state.common.loaded,
  commonInfo: state => state.common.commonInfo,
  decorateInfo: state => state.common.decorateInfo,
  openEdit: state => state.common.openEdit,
  showFooter: state => state.common.showFooter,
  userInfo: state => state.common.userInfo,
}
export default getters
